// @flow
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import Card from "@material-ui/core/Card";
import React from "react";
import Emoji from "a11y-react-emoji";

function ScheduleGameCardEmpty() {
  return (
    <Card>
      <CardContent>
        <Typography variant="h3" align="center" component="p">
          <Emoji symbol="👀" label="Augen" />
        </Typography>
        <Typography
          variant="body1"
          color="textSecondary"
          align="center"
          component="p"
        >
          Es stehen keine Spiele in deiner aktuellen Auswahl mehr an.
        </Typography>
      </CardContent>
    </Card>
  );
}

export default ScheduleGameCardEmpty;
